<template>
  <div style="margin-top: -7rem !important;">
    <div class="page-header-card mb-3" :class="{ 'nav-orange-gradient-bg' : $getSiteId() == 33, 'nav-green-gradient-bg' : $getSiteId() == 35 }">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-4 mt-5">
            <div class="vx-col w-full text-center">
              <custom-svg variant="campus" width="80" height="80" color="white" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">campus</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coming-soon></coming-soon>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import ComingSoon from '@/gen-2/components/ComingSoon.vue';
export default {
  components: {
    CustomSvg,
    ComingSoon
  },
  data() {
    return {
      
    };
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {
    
  },
  mounted() {
    
  }
};
</script>